import { useExperiment, useExperimentTrackingData, useExperiments, } from '../contexts/experiments';
import { useFeatureSwitches, } from '../contexts/feature-switches';
import { useFeatures } from '../contexts/features';
import { useMetaConfig } from '../contexts/meta-config';
import { useLink } from '../contexts/react-link';
import { useAppliedTheme, useThemeSettings } from '../contexts/theming';
import { useViewerData } from '../contexts/viewer-data';
import { useFrameContext } from '../contexts/xing-frame';
const frameHooks = {
    useExperiment: (name) => {
        return useExperiment(name, 'A');
    },
    useExperimentsLoadingState: () => {
        return { isLoading: useExperiments().loading };
    },
    useExperimentTrackingData: () => {
        return useExperimentTrackingData();
    },
    useFetchExperiments: () => {
        const { loading: isLoading, data: experiments = {} } = useExperiments();
        return { isLoading, experiments };
    },
    useFeatureSwitches: () => {
        const { data: featureSwitches } = useFeatureSwitches();
        return featureSwitches
            ? { loading: false, featureSwitches }
            : { loading: true };
    },
    useFrameContext: () => {
        const frameContext = useFrameContext();
        const { data: metaConfig = {
            refetchPeriodically: typeof frameContext.pollInterval !== 'undefined',
        }, } = useMetaConfig();
        return { ...frameContext, metaConfig };
    },
    useInitialData: () => {
        const { data: features = {} } = useFeatures();
        const { data: featureSwitches = [] } = useFeatureSwitches();
        const { data: viewerData } = useViewerData();
        const { hashedUserId = '', networkEfficiencyIndicator = {}, user = {}, willingnessToChangeJobs = 0, } = viewerData !== null && viewerData !== void 0 ? viewerData : {};
        return {
            loading: !viewerData,
            features,
            featureSwitches,
            hashedUserId,
            networkEfficiencyIndicator,
            user,
            willingnessToChangeJobs,
        };
    },
    useIsDarkMode: () => {
        return useAppliedTheme() === 'dark';
    },
    useLinkComponent: () => {
        return useLink();
    },
    useMetaConfig,
    useTheme: () => {
        return useThemeSettings();
    },
};
export function useFrameHooks() {
    return frameHooks;
}
//# sourceMappingURL=frame-hooks.js.map